import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { UserApiModel } from './../models/user-api.model';

@Injectable()
export class MwUserApiService {
  constructor(private http: MwHttpService) {}

  getUsers(): Observable<UserApiModel[]> {
    return this.http.authGet<UserApiModel[]>(
      `/integration/v1/Companies/{companyId}/Users?$orderby=FirstName,LastName`
    );
  }
}
